/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-cond-assign */
/* eslint-disable no-console */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-rest-params */
;(function () {
  /**
   * Please use ES5 Syntax while updating this file. As Minification tool is corrupting the file if its in ES6+
   */
  const webViewLogger = window.loggerUtility || function () {}
  const eventSource = { stepName: '' }

  const env = (window.URLConstants && window.URLConstants.buildEnv) || 'dev'
  function logInfoToConsole(name, data) {
    if (env !== 'prod') {
      console.log(name, data || '')
    }
  }

  function getQueryStringData() {
    let key = false
    const res = {}
    let itm = null
    // get the query string without the ?
    const qs = location.search.substring(1)
    // check for the key as an argument
    if (arguments.length > 0 && arguments[0].length > 1) key = arguments[0]
    // make a regex pattern to grab key/value
    const pattern = /([^&=]+)=([^&]*)/g
    // loop the items in the query string, either
    // find a match to the argument, or build an object
    // with key/value pairs
    while ((itm = pattern.exec(qs))) {
      if (key !== false && decodeURIComponent(itm[1]) === key)
        return decodeURIComponent(itm[2])
      if (key === false)
        res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2])
    }
    return key === false ? res : null
  }

  window.ReactInterfaceHandler = function (handler, data) {
    console.log('ReactInterfaceHandler call')
    let event = ''
    switch (handler) {
      case 'TUXIntegration':
        eventSource.stepName = 'Native TUXIntegration'
        try {
          webViewLogger({ level: 'info', eventSource })
          logInfoToConsole('#### Native TUXIntegration !!!', data)
          event = new Event('getAggregateDetails')
          document.dispatchEvent(event)
        } catch (error) {
          webViewLogger({
            level: 'error',
            error,
            exceptionMsg: 'Native TUXIntegration handler Error',
            eventSource
          })
        }
        break

      case 'TransmitToken':
        logInfoToConsole('#### Native Transmitter token !!!', data)
        eventSource.stepName = 'Native Transmitter token'
        try {
          webViewLogger({ level: 'info', eventSource })
          const tokenResponse = JSON.parse(data)
          const { token = '', error } = tokenResponse || {}
          if (token) sessionStorage.transmitterToken = token
          event = new CustomEvent('getTransmitterToken', {
            detail: { errorCode: error }
          })
        } catch (error) {
          webViewLogger({
            level: 'error',
            error,
            exceptionMsg: 'Native Transmitter token handler Error',
            eventSource
          })
        }
        document.dispatchEvent(event)
        break

      case 'OnBackAction':
        logInfoToConsole('#### Native back click  !!!', JSON.parse(`${data}`))
        eventSource.stepName = 'Native back click'
        try {
          webViewLogger({ level: 'info', eventSource })
        } catch (error) {
          webViewLogger({
            level: 'error',
            error,
            exceptionMsg: 'Native back handler Error',
            eventSource
          })
        }
        event = new CustomEvent('OnBackAction', {
          detail: JSON.parse(`${data}`)
        })
        document.dispatchEvent(event)
        break

      case 'handleLoader':
        logInfoToConsole('#### handleLoader  !!!', JSON.parse(`${data}`))
        eventSource.stepName = 'handleLoader'
        try {
          webViewLogger({ level: 'info', eventSource })
        } catch (error) {
          webViewLogger({
            level: 'error',
            error,
            exceptionMsg: 'handleLoader',
            eventSource
          })
        }
        event = new CustomEvent('handleLoader')
        document.dispatchEvent(event)
        break

      default:
        logInfoToConsole('### No handlers defined ###')
    }
  }

  const { accessToken = '', routingKey = '' } = getQueryStringData()
  accessToken && sessionStorage.setItem('AccessToken', accessToken)
  routingKey && sessionStorage.setItem('routingKey', routingKey)

  logInfoToConsole(window, '~~~self execution function~~~')
})()
